var axios = require('axios');
var instance = null;
var url='https://thucoin.thu.edu.tw:5000';
var store = require('./../store');

module.exports.axiosTokenGet = function(path) {

	instance=axios.create({
	   baseURL:url,
	   responseType:'application/json',
	    headers: {
	        'Content-Type': 'application/json',
	        'Authorization': store.default.state.accessToken
	    }
	});

	return instance.get(path);
};

module.exports.axiosTokenPost = function(path,params) {
	instance=axios.create({
	   baseURL:url,
	   responseType:'application/json',
	    headers: {
	        'Content-Type': 'application/json',
	        'Authorization': store.default.state.accessToken
	    }
	});

	return instance.post(path,params);
};

module.exports.axiosPost = function(path,params) {
	instance=axios.create({
	   baseURL:url,
	   responseType:'application/json',
	    headers: {
	        'Content-Type': 'application/json'
	    }
	});

	return instance.post(path,params);
};
module.exports.axiosOAuthPost = function(path,params) {
	instance=axios.create({
		baseURL:url,
		responseType:'application/json',
		headers: {
			'Content-Type' : 'application/json'
		},
		auth : {
			username:'Oa6N2SZeyHvZ9WNUbkBbpowcmWsPyD',
			password:'OnNUbPNa4lSzl1w9VHtxTTWp6imy8V'
		}
	 });
 
	 return instance.post(path,params);
};


module.exports.axiosGet = function(path) {

	instance=axios.create({
	   baseURL:url,
	   responseType:'application/json',
	    headers: {
	        'Content-Type': 'application/json',
	    }
	});

	return instance.get(path);
};



// WEBPACK FOOTER //
// ./src/js/axiosModule.js